import {useUserStore} from '@/stores/user';
// import {useAuth} from "@/composables/useAuth";

export default defineNuxtRouteMiddleware( (to, from) => {

    if (process.server) {
        return

    } else {
        const userStore = useUserStore();
        const token = userStore.getToken;
        if (!token) {
            return navigateTo({
                path: '/',
                query: {
                    ...to.query,
                    redirect: to.fullPath
                },
            });
        }
    }

});
